import { Modal, Button } from 'flowbite-react';
import React from 'react';
import { RxCross2 } from 'react-icons/rx';
import { useNavigate } from 'react-router-dom';

interface Props {
	isOpen: boolean;
	onClose: () => void;
	positionTitle: string;
	companyName: string;
	workexp: number;
}

const MisMatchModal = ({ isOpen, onClose, positionTitle, companyName, workexp }: Props) => {
	const navigate = useNavigate();
	return (
		<Modal dismissible={true} size={'md'} show={isOpen} onClose={onClose}>
			<Modal.Body className="relative flex flex-col gap-y-8 justify-center rounded-[8px] border border-solid border-[#555770] bg-[#18222D] p-8 ">
				<div className="flex flex-col gap-y-6 text-base	text-[#C7C9D9]">
					{`Your experience doesn't match the requirements for “${positionTitle} at ${companyName}” position, which mandates ${workexp} years.`}
					<p className="text-base text-[#C7C9D9]"> Explore other suitable job listings for you.</p>
				</div>
				<div className="flex justify-center">
					<Button color="purplePlaced" size={'md'} onClick={() => navigate('/jobs')}>
						View Applicable Positions
					</Button>
				</div>

				<RxCross2
					onClick={onClose}
					className="absolute right-[10px] top-[10px] h-[20px] w-[20px] cursor-pointer text-[#9CA3AF]"
				/>
			</Modal.Body>
		</Modal>
	);
};

export default MisMatchModal;
